export const fixDatePickers = {
    created() {
        this.$bus.$on("fix-pickers", delay => {
            let d = delay || 300;
            setTimeout(this.removePickerMinWidth, d);
        });
    },
    mounted() {
        setTimeout(this.removePickerMinWidth, 300);
    },
    methods: {
        removePickerMinWidth() {
            let el = document.querySelectorAll("input[placeholder='MM/DD/YYYY']");
            if (el.length) {
                el.forEach(e => {
                    e.style.border = "none";
                    e.style.minWidth = "unset";
                    e.style.maxWidth = "5rem";
                });
            }
        },
    },
};
